import React, { useEffect } from 'react'
import Modal from "react-modal";
import { isAutoServicesTenant } from '../../../utils/tenantBranding';


Modal.setAppElement("#root");

interface TermsAndConditionsModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const PrivacyPolicyModal: React.FC<
  TermsAndConditionsModalProps
> = ({ isOpen, onRequestClose }) => {

  useEffect(() => {
    if (isOpen) {
      //   setAcceptTerms(false);
      //   setIsProcessing(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    onRequestClose();
  };
  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
  const brandName = autoServicesBranding ? "Autoservices" : "EURO REPAR";
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleClose}
        contentLabel="Terms and Conditions"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            maxHeight: "80vh",
            padding: "0",
            borderRadius: "8px",
            border: "none",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#fff",
            borderRadius: "8px",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "20px",
              borderBottom: "1px solid #e0e0e0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <h2 style={{ margin: 0, color: "#333", fontSize: "24px" }}>
           Privacy Policy
            </h2>
            <button
              onClick={handleClose}
              style={{
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#666",
                padding: "0",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ×
            </button>
          </div>

          {/* Scrollable Content */}
          <div
            style={{
              flex: 1,
              padding: "20px",
              overflowY: "auto",
              lineHeight: "1.6",
              color: "#333",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                1. Introduction
              </h3>
              <p>
                This website is owned by {!autoServicesBranding ? "Stellantis" : "Autoservices"}  Automobiles India Private Limited and operated by it under name {autoServicesBranding ? "Auto Services Car Service" : "Euro Repar Car Service"}. The registered office of {!autoServicesBranding ? "Stellantis" : "Autoservices"}  Automobiles India Private Limited is situated in {!autoServicesBranding && " Adhigattur Village, Kadambathur P.O., Thiruvallur, Tiruvallur, Tamil Nadu, 631203. This website is hosted in India by our IT-service provider BOTGO TECHNOLOGIES PRIVATE LIMITED,"} B-67, Sector – 67, CESPL Building, Noida, Gautam Buddha Nagar, Uttar Pradesh (India), Pin – 201301.

                Please read this policy carefully before using this website because it explains how we will process personal data. Using this website indicates that you accept this policy
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                1. Types of data being processed / Links to other websites/applications
              </h3>
              <p>
                We care about your privacy. We collect and process various types of personal data via this website. This includes:

                · Information you provide to us when requesting and using our services and our website, such as name, address, e-mail address, as well as image files uploaded by you as a user.

                · Information that we need when you report a problem with our website

                · Information collected with cookies

                · Information about your vehicle and specific contract data that we need for the individual performance of the website (e.g. vehicle model, service dates) and to provide a positive usage experience with the best service for your vehicle

                This website may also contain links to other {brandName} websites/applications or to websites/applications of our {brandName} Car Service partners, authorized workshops, other affiliated companies or social media websites. When you click on such a link to any of such other {brandName} Car Service or third party websites/applications, please be aware that these websites/applications have their own Data Protection policies. Please check their privacy policies when using these websites/applications.

                Please be informed that {brandName} Car Service cannot accept any responsibility or liability for third party websites/applications.
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                2. Information about the processing of personal data
              </h3>
              <p>
                Your personal data will be processed to fulfil your request and for registration and general administration purposes related to your {brandName} Car Service Website account.

                We as controllers process your personal data as follows:

                Data / Data Categories (mandatory data is marked with an *) Purpose(s)

                Respective identification and contact details

                (name*, email address*; phone no., postal address), password*,

                vehicle identification data (e.g. vehicle identification number (VIN)*,

                registration number / license plate, model year) specific vehicle (Pre-)Registration process: Information you provide to us when (pre-) registering,

                related information (e.g. ownership type*, new/used, mileage), preferred dealer* (sales / service) requesting and using our services and our website.

                Respective identification and contact details

                (name*, email address*; phone no., postal address (* if applicable)),

                model of interest details*, {brandName} Car Service SAS Partner*,

                leasing / financing interest, enquiry type (* if applicable), fleet

                specific data (* if applicable) Contacting, communication and request fulfilment

                Respective identification and contact details

                (name, email address)* Newsletter un-/subscription

                Respective identification and contact details

                (name*, email address*; phone no., postal address (* if applicable),

                contact preferences),

                vehicle identification data (e.g. vehicle identification number (VIN)*,

                registration number / license plate, first registration date), product

                and service specifications (e.g. model, trim, engine), service type*,

                odometer reading, vehicle drop off date/time, pickup date/time,

                courtesy car Service Request fulfilment

                Respective identification and contact details*, vehicle identification

                data*, respective product specifications*, odometer reading Vehicle Valuation request fulfilment

                Respective identification and contact details

                (name*, phone no.) Request fulfilment tracking

                Respective identification and contact details

                (name*, email address*; phone no., postal address, date of birth*),

                password*, respective contract related information (e.g.

                acceptance of terms & conditions) Registration of website account and provision of connected services and alert notifications.

                Information collected via cookies please see Cookies Policy for detailed information

                The data elements marked with an asterisk (*) are mandatory and a contractual requirement. You are therefore obliged to provide the data when you register or request certain EURO REPAR Car Service SAS- related services. In case you don’t provide the data, we cannot fulfil your request.

                Your personal data will be stored for ten years after inactivity.

                We disclose your personal data for the below listed purposes to the following recipients:

                A. Purposes related to the performance of a contract or related to steps at the request of the data subject prior to entering into a contract according to Art. 6 (1) 1 b) General Data Protection Regulation (GDPR)
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                3 Interaction with social networks                </h3>
              <p>
                3.1 Customer care and assistance via Social Media

                You may contact us also via our Social Media Channels. E.g., if you send us a message or post something on our Social Media Channels, we may use the information in your message or post to follow-up with you on the issue you contacted us for via the Social Media Channel which you used. In order to give you the assistance you requested, we may ask you to provide via direct or private message further information such as details on the issue, name, email, VIN, phone, location (city/state) and/or make, model and year of the vehicle. The information you provide will not be used for direct marketing; market research for service and product improvement will only be carried out on bases of aggregated (anonymized) data.

                Please note that you should not include any sensitive data (such as information on racial or ethnic origin, political opinions, religious or philosophical convictions, or health) into you post or message. Be aware that if you post something on a public Social Media Channel, anyone might be able to read it.

                3.2 Links to social networks / social media plug-ins

                Our website includes links to social networks.

                In order to protect your personal data while visiting our website we do not use social plugins. Instead HTML-links are embedded onto the website, enabling easy sharing onto social media platforms. Embedding the link prevents a direct connection with various social media network servers when opening a page from our website. When clicking on one of the buttons, a browser window opens and directs the user to the respective service provider website on which (after having logged in) for example, the “Like” or “Share” button can be used.

                For more information on the purpose and scope of data processing and further use of your personal data by the provider and their websites as well as your rights and possible settings to protect your privacy, please refer to the data protection information of the respective service provider. Facebook: http://www.facebook.com/policy.php Twitter: https://twitter.com/privacy Instagram: https://help.instagram.com/155833707900388 You Tube: https://www.google.de/intl/de/policies/privacy/ LinkedIn: https://www.linkedin.com/legal/privacy-policy
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                5. Service Limitations
              </h3>
              <p>
                While we strive to provide excellent service, we cannot
                guarantee that our services will be uninterrupted or error-free.
                Service availability may vary.
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                6. Payment Terms
              </h3>
              <p>
                Payment for services is due upon completion unless otherwise
                arranged. We accept various payment methods as displayed during
                the booking process.
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                7. Cancellation Policy
              </h3>
              <p>
                Service cancellations must be made at least 24 hours in advance.
                Cancellations made with less notice may be subject to
                cancellation fees.
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                8. Liability Limitations
              </h3>
              <p>
                Our liability is limited to the cost of the service provided. We
                are not responsible for indirect, incidental, or consequential
                damages.
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                9. Modifications to Terms
              </h3>
              <p>
                We reserve the right to modify these terms at any time. Users
                will be notified of significant changes, and continued use
                constitutes acceptance of modified terms.
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                10. Contact Information
              </h3>
              <p>
                For questions about these terms and conditions, please contact
                us through our customer service channels available on our
                website.
              </p>
            </div>

            {/* Checkbox at the bottom */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "15px",
                borderRadius: "5px",
                marginTop: "20px",
                border: "1px solid #e0e0e0",
                position: "relative",
              }}
            >
              {/* <div
                 style={{
                   display: "flex",
                   alignItems: "center",
                   gap: "10px",
                   opacity: isProcessing ? 0.7 : 1,
                   transition: "opacity 0.3s ease",
                 }}
               >
                 <input
                   type="checkbox"
                   id="accept_terms_modal"
                   checked={acceptTerms}
                   onChange={handleCheckboxChange}
                   disabled={isProcessing}
                   style={{
                     width: "16px",
                     height: "16px",
                     cursor: isProcessing ? "not-allowed" : "pointer",
                   }}
                 />
                 <label
                   htmlFor="accept_terms_modal"
                   style={{
                     margin: 0,
                     fontSize: "14px",
                     color: "#333",
                     cursor: isProcessing ? "not-allowed" : "pointer",
                     fontWeight: "500",
                   }}
                 >
                   I accept the Terms and Conditions
                 </label>
               </div> */}

              {/* Loading indicator */}
              {/* {isProcessing && (
                 <div
                   style={{
                     position: "absolute",
                     top: "50%",
                     right: "15px",
                     transform: "translateY(-50%)",
                     display: "flex",
                     alignItems: "center",
                     gap: "8px",
                     color: "#007bff",
                     fontSize: "12px",
                   }}
                 >
                   <div
                     style={{
                       width: "16px",
                       height: "16px",
                       border: "2px solid #f3f3f3",
                       borderTop: "2px solid #007bff",
                       borderRadius: "50%",
                       animation: "spin 1s linear infinite",
                     }}
                   />
                   <span>Processing...</span>
                 </div>
               )} */}
            </div>
          </div>
        </div>
      </Modal>

      {/* 🔄 Moved outside jsx */}
      <style>
        {`
           @keyframes spin {
             0% {
               transform: rotate(0deg);
             }
             100% {
               transform: rotate(360deg);
             }
           }
         `}
      </style>
    </>
  )
}

export default PrivacyPolicyModal